import { Card, CardActionArea, CardMedia, Typography } from '@mui/material'

import { ArtistStoreCollectionBoxFragment } from '@/clients/utoniq-core/schema'
import { styleSets } from '@/components/styles'
import { config } from '@/config'
import { useRouter, useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'
import { useAnalytics } from '@/lib/analytics'

type ArtistStoreCollectionBoxProps = {
  collection: ArtistStoreCollectionBoxFragment
  width?: number | string
  height?: number | string
  /** analyticsクリックイベント時の導線名 */
  conductorName: string
  /** レスポンシブ対応（trueの場合は画面横幅に応じて拡縮する） */
  responsive?: boolean
  /** 画像のアスペクト比 レスポンシブ対応時のみ有効*/
  aspectRatio?: string
}

export const ArtistStoreCollectionBox: Organism<ArtistStoreCollectionBoxProps> =
  ({
    collection,
    width,
    height = 90,
    aspectRatio = '1000 / 560',
    conductorName,
    responsive = false,
  }) => {
    const { t } = useTranslation('storeCollectionsSelect')
    const { generatePath, routerPages } = useRouter()
    const { analytics } = useAnalytics()
    const thumbnailUri =
      collection.thumbnail.mediumUri ?? collection.thumbnail.uri ?? ''

    return (
      <OrganismFrame>
        <Card elevation={0} sx={{ bgcolor: 'transparent', width }}>
          <CardActionArea
            href={generatePath(routerPages.StoreCollectionDetail, {
              artistId: collection.artistId,
              collectionId: collection.id,
            })}
            onClick={() => {
              analytics?.track('click_select', {
                applicationKey: config.applicationKey,
                artistId: collection.artistId,
                collectionId: collection.id,
                name: conductorName,
              })
            }}
          >
            <CardMedia
              component="img"
              image={thumbnailUri}
              sx={{
                borderRadius: 1,
                width: responsive ? '100%' : width,
                height: responsive ? '100%' : height,
                objectFit: responsive ? 'cover' : undefined,
                aspectRatio: responsive ? aspectRatio : undefined,
              }}
              alt={collection.title}
            />
            <Typography variant="subtitle1" sx={styleSets.lineCamp(1)}>
              {collection.title}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block' }}
            >
              {t('itemCount', { count: collection.publishedItemCount })}
            </Typography>
          </CardActionArea>
        </Card>
      </OrganismFrame>
    )
  }
